import * as actionTypes from '../../constants/actionTypes';

export const addProcess =
  (type, description, data, autoRemove = false, progressRequestType = null) =>
  (dispatch) => {
    if (autoRemove) {
      setTimeout(() => dispatch(removeProcess(type, data)), 4000);
    }

    return dispatch({
      type: actionTypes.ADD_PROCESS,
      payload: {
        type,
        description,
        data,
        progressRequestType,
      },
    });
  };

export const removeProcess = (type, data) => {
  return {
    type: actionTypes.REMOVE_PROCESS,
    payload: {
      type,
      data,
    },
  };
};
